import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import DoorlockUninstall from './DoorlockUninstall';
import DoorlockBatteryLogList from './DoorlockBatteryLog';
import DoorlockLogList from './DoorlockLogList';
import { doorlockTypeFormatter, doorlockStatusFormatter, dateFormatter } from '../../../lib/formatter';
import doorlockFormatter from './DoorlockFormatter';

const DoorlockDetail = ({
  doorlockId,
  selectedDoorlockItem,
  doorlockLogListTotal,
  doorlockLogListItems,
  doorlockBatteryLogListItems,
  doorlockLogListFilterItem,
  doorlockLogListSortItem,
  doorlockLogListPaginationItem,
  doorlockBatteryLogListFilterItem,
  setDoorlockLogListFilterItem,
  setDoorlockLogListSortItem,
  setDoorlockLogListPaginationItem,
  setDoorlockBatteryLogListFilterItem,
  selectDoorlockApi,
  moveToListPage,
  inAnotherDetailPage,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenDoorlockUninstallModal, setIsOpenDoorlockUninstallModal ] = useState(false);
  const [ activeTab, setActiveTab ] = useState(1);

  const selectDoorlockUninstall = () => {
    if (selectedDoorlockItem.status !== 'installed') return;
    setIsOpenDoorlockUninstallModal(true);
  };

  return (
    <Fragment>
      <div hidden={inAnotherDetailPage}>
        <div className='content-title2'>
          <h3>
            <span onClick={moveToListPage}><FontAwesomeIcon icon={faArrowLeft}/></span>
            {t('content_title.doorlock_detail')}
          </h3>
        </div>
        <div className='content-title'></div>
      </div>
      <div className='form-tab'>
        <p className={`tab-item ${activeTab !== 1 ? 'inactive':''}`} onClick={() => setActiveTab(1)}>{t('tab_column.doorlock_detail')}</p>
        <p className={`tab-item ${activeTab !== 2 ? 'inactive':''}`} onClick={() => setActiveTab(2)}>{t('tab_column.battery_chart')}</p>
        <p className={`tab-item ${activeTab !== 3 ? 'inactive':''}`} onClick={() => setActiveTab(3)}>{t('tab_column.doorlock_log')}</p>
      </div>
      <div className='form-card detail tab' hidden={activeTab !== 1}>
        <div className='form-card-title detail'>
          <div hidden className={`form-dropdown detail ${selectedDoorlockItem.status !== 'installed' ? 'disabled':''}`} onClick={() => selectDoorlockUninstall()}>
            <span><FontAwesomeIcon icon={faTrashAlt}/></span>
          </div>
        </div>
        <div className='inline-flex'>
          <div className='w-50'>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faLock}/> */}
                <b>{t('data_column.doorlock_name')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.name || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faSignature}/> */}
                <b>{t('data_column.doorlock_serial')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.serial || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faDoorOpen}/> */}
                <b>{t('data_column.status')}</b>
              </p>
              <p className='card-text-display'>{doorlockStatusFormatter(selectedDoorlockItem.status) || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faBuilding}/> */}
                <b>{t('data_column.building')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.buildingName || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                <b>{t('data_column.floor')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.floorName || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faTag}/> */}
                <b>{t('data_column.type')}</b>
              </p>
              <p className='card-text-display'>{doorlockTypeFormatter(selectedDoorlockItem.type) || '-'}</p>
            </div>
          </div>
          <div className='w-50'>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faInfoCircle}/> */}
                <b>{t('data_column.fw_type')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.fwType ? doorlockFormatter.fwType(selectedDoorlockItem.fwType):'-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faCodeBranch}/> */}
                <b>{t('data_column.fw_version')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.fwVersion || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faBatteryThreeQuarters}/> */}
                <b>{t('data_column.battery_status')}</b>
              </p>
              <p className='card-text-display'>{selectedDoorlockItem.fwBattery ? `${selectedDoorlockItem.fwBattery}%` : '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faHammer}/> */}
                <b>{t('data_column.created_at')}</b>
              </p>
              <p className='card-text-display'>{dateFormatter(selectedDoorlockItem.createdAt) || '-'}</p>
            </div>
            <div className='card-text'>
              <p>
                {/* <FontAwesomeIcon icon={faWrench}/> */}
                <b>{t('data_column.updated_at')}</b>
              </p>
              <p className='card-text-display'>{dateFormatter(selectedDoorlockItem.updatedAt) || '-'}</p>
            </div>
          </div>
        </div>
        <div className='card-foot detail'>
        </div>
      </div>
      <div className='form-card detail tab' hidden={activeTab !== 2}>
        <DoorlockBatteryLogList
          doorlockBatteryLogListItems={doorlockBatteryLogListItems}
          filterItem={doorlockBatteryLogListFilterItem}
          setFilterItem={setDoorlockBatteryLogListFilterItem}
        />
      </div>
      <div className='form-card detail tab' hidden={activeTab !== 3}>
        <DoorlockLogList
          doorlockLogListTotal={doorlockLogListTotal}
          doorlockLogListItems={doorlockLogListItems}
          filterItem={doorlockLogListFilterItem}
          sortItem={doorlockLogListSortItem}
          paginationItem={doorlockLogListPaginationItem}
          setFilterItem={setDoorlockLogListFilterItem}
          setSortItem={setDoorlockLogListSortItem}
          setPaginationItem={setDoorlockLogListPaginationItem}
          inDetailPage={true}
          history={history}
        />
      </div>
      <DoorlockUninstall
        isOpen={isOpenDoorlockUninstallModal}
        toggle={() => setIsOpenDoorlockUninstallModal(!isOpenDoorlockUninstallModal)}
        reload={() => selectDoorlockApi()}
        doorlockId={doorlockId}
        doorlockName={selectedDoorlockItem.name}
      />
    </Fragment>
  );
};

export default DoorlockDetail;